import { getStore } from '~/mobx/AppStore';
import candidateApi from '~/clientApis/candidateApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';

const deleteCandidate = async () => {
    const { candidateStore } = getStore();
    if (!candidateStore.selectedCandidateId) {
        showMessageModal('error', 'No candidate selected for deletion');
        return;
    }

    candidateStore.setDeletingCandidate(true);

    let deleteSuccess = false;
    try {
        await candidateStore.unlinkMedia();
        await candidateStore.unlinkCandidateFromRegion();
        await candidateApi.deleteCandidate(candidateStore.selectedCandidateId);
        candidateStore.resetDetailForm();
        deleteSuccess = true;
    } catch {
        showMessageModal('error', 'Error deleting candidate');
    } finally {
        candidateStore.setDeletingCandidate(false);

        if (deleteSuccess) {
            candidateStore.cancelEdit();
        }
    }
};

export default deleteCandidate;
